import { isEqual, isNil, pick } from 'lodash-es';

import { CustomizerSessionState } from '../types';

export function clearObjectEmptyValues<T extends Record<string, any>>(object: T): Record<string, any> {
  const cleanObject = Object.entries(object).filter(([_, value]) => !isNil(value));

  return Object.fromEntries(cleanObject);
}

export function areStatesEqual(
  prevState: CustomizerSessionState = {},
  nextState: CustomizerSessionState = {},
): boolean {
  const keys: Array<keyof CustomizerSessionState> = ['brandName', 'country', 'domain', 'logo'];

  const prev = clearObjectEmptyValues(pick(prevState, keys));
  const next = clearObjectEmptyValues(pick(nextState, keys));

  // Empty state on mount / fresh state on first visit
  if (Object.keys(next).length === 0) {
    return true;
  }

  return isEqual(prev, next);
}
